<template>
  <div>
    <div v-if="loading" class="c-search-results__loading-wrapper">
      <div class="c-search-results__loading-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="c-search-results__wrapper">
      <div class="c-search-results__container">
        <div v-if="hasSearched">
          <div v-if="searchResult.results.length == 0">
            Sorry, there are no results.
          </div>
          <div>
            <div v-if="searchResult.results.length">
              <h3 class="c-search-results__found">
                <p v-if="searchResult.totalResults == 1">
                  You have 1 result for
                  <span class="c-search-results__found-term">
                    "{{ searchResult.searchTerm }}"</span>{{ calcResultsShowing() }}
                </p>
                <p v-else>
                  You have {{ searchResult.totalResults }} results for
                  <span class="c-search-results__found-term">
                    "{{ searchResult.searchTerm }}"</span>{{ calcResultsShowing() }}
                </p>
              </h3>
            </div>
          </div>
          <div
            v-for="result in searchResult.results"
            :class="[`c-search-results__result--${result.className}`]"
            :key="result.title + result.id"
          >
            <SubmissionResult
              v-if="result.category == 'Submission'"
              :result="result"
            ></SubmissionResult>
            <PublicationResult
              v-else-if="result.category == 'Publication'"
              :result="result"
            >
            </PublicationResult>
            <NewsResult v-else-if="result.category == 'News'" :result="result">
            </NewsResult>
            <DefaultResult v-else :result="result"> </DefaultResult>
          </div>

          <div
            class="c-search-results__pagination"
            v-if="searchResult.results.length > 0"
          >
            <button
              class="c-search-results__pagination-link c-search-results__pagination-link-prev button button--plain button--small"
              v-if="searchResult.currentPage > 1"
              @click="prevPageSearch"
            >
            <span class="c-search-results__pagination-link-chevron"></span>
              Previous
            </button>
            <p class="c-search-results__pagination__text">
              Page {{ searchResult.currentPage }} of {{ searchResult.totalPages }}
            </p>
            <button
              class="c-search-results__pagination-link c-search-results__pagination-link-next button button--plain button--small"
              v-if="searchResult.currentPage < searchResult.totalPages"
              @click="nextPageSearch"
            >
              Next
              <span class="c-search-results__pagination-link-chevron"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import SubmissionResult from "./result/SubmissionResult.vue";
import PublicationResult from "./result/PublicationResult.vue";
import NewsResult from "./result/NewsResult.vue";
import DefaultResult from "./result/DefaultResult.vue";

export default {
  data() {
    return {};
  },
  components: {
    SubmissionResult,
    PublicationResult,
    NewsResult,
    DefaultResult,
  },
  mounted() {},
  computed: {
    ...mapFields([
      "searchApp.searchResult",
      "searchApp.searchResult.totalResults",
      "searchApp.searchResult.currentPage",
      "searchApp.state.hasSearched",
      "searchApp.state.loading",
      "searchApp.searchSubmission.start",
      "searchApp.searchResult.searchTerm",
    ]),
  },
  methods: {
    nextPageSearch() {
      this.start = this.searchResult.nextStart;
      this.$store.dispatch("submitSearch");
    },
    prevPageSearch() {
      this.start = this.searchResult.prevStart;
      this.$store.dispatch("submitSearch");
    },
    calcResultsShowing() {
      let perPage = 15;

      // calculate the number range of results showing
      // if we only have 1 page, return blank
      if (this.totalResults < 16) {
        return "";
      }
      const start = (this.currentPage - 1) * perPage + 1;
      const end = Math.min(this.currentPage * perPage, this.totalResults);
      return `, showing ${start} to ${end}`;
    },
  },
};
</script>

<style lang="scss">
.c-search-results__loading-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 50px;
  background-color: colour(off-white);
}

.c-search-results__loading-ring {
  display: inline-block;
  position: relative;
  width: 60px;
  height: 60px;

  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 54px;
    height: 54px;
    margin: 8px;
    border: 8px solid colour(dark-green);
    border-radius: 50%;
    animation: loading-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: colour(dark-green) transparent transparent transparent;
  }
  div:nth-child(1) {
    animation-delay: -0.45s;
  }
  div:nth-child(2) {
    animation-delay: -0.3s;
  }
  div:nth-child(3) {
    animation-delay: -0.15s;
  }
}
@keyframes loading-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.c-search-results__empty {
  @include t5-heading;
  font-style: italic !important;
  margin-bottom: 48px !important;
}

.c-search-results__found {
  @include t5-heading;
  font-style: italic !important;
  margin-bottom: 48px !important;
}

.c-search-results__found-term {
  color: colour(green2);
}

.c-search-results__pagination {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;

  @include breakpoint(sm-and-up) {
    width: 50%;
    margin: 20px auto 0;
  }
}

.c-search-results__pagination-link {
  font-family: $bodyFont;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  background: colour(white);

  &:hover {
    color: colour(white);
    background: colour(dark-green);

    .c-search-results__pagination-link-chevron {
        background-image: url('/_resources/app/client/assets/icons/chevron-white.svg');
    }
  }
}

.c-search-results__pagination-link-chevron {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-image: url('/_resources/app/client/assets/icons/chevron.svg');
  background-repeat: no-repeat;
  background-position: center;
}
  
.c-search-results__pagination-link-prev .c-search-results__pagination-link-chevron {
  transform: rotate(90deg);
}

.c-search-results__pagination-link-next .c-search-results__pagination-link-chevron {
  transform: rotate(-90deg);
}

.c-search-results__pagination__text {
  margin: 0 10px;
  @include breakpoint(sm-and-up) {
    margin: 0 80px;
  }
}

.c-search-results__wrapper {
  background-color: colour(off-white);
}

.c-search-results__container {
  max-width: 1440px;
  padding: 80px 16px;
  margin: auto;
}
</style>
